import { render, staticRenderFns } from "./RealTimeTelMain.vue?vue&type=template&id=dec218e6"
import script from "./RealTimeTelMain.vue?vue&type=script&lang=js"
export * from "./RealTimeTelMain.vue?vue&type=script&lang=js"
import style0 from "./RealTimeTelMain.vue?vue&type=style&index=0&id=dec218e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports